import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import PageTitleAndSubTitle from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/PageTitleAndSubtitle';
import MedicalHistoryDetails from '../../_components/organisms/MedicalHistoryDetails';
import BasicTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import { observer } from 'mobx-react';
import React, { ChangeEvent, useEffect, useState } from 'react';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  collapsiblePatientTableColumns,
  MemberClaims,
  RiskPatientListData,
  RiskPatientDetailss,
  formatMemberClaim,
  formatSubheadRiskTier,
  getTextWithToolTip,
  collapsiblePatientTableHeaderStyles,
} from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import { Breadcrumbs } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { riskPatientDetailsMessage } from '../../core-utils/messages/riskPatientDetailsConstants';
import { useNavigate, useLocation } from 'react-router-dom';
import { numberToCurrencyFormatter } from '../../core-utils/helper-utils/helper';
import { PATIENT_DETAILS, SUMMARY } from '../../core-utils/routes';
import { useStores } from '../../stores';
// import { MonthMap } from '../../core-utils/helper-utils/EditDuration';
// import moment from 'moment';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import moment from 'moment';
import { defaultRiskPatientColumns } from '../../core-utils/helper-utils/customColumnsHelper';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';

export interface RiskPatientDetailsPageProps {}

const RiskPatientDetailsPage: React.FC<RiskPatientDetailsPageProps> = observer(
  ({}) => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 0px 66px 63px',
      },
    });

    //state variables
    const [loading, setLoading] = useState<boolean>(true);
    const [page, setPage] = useState(1);

    const [pageSize] = useState<number>(10);

    const [risKPatientListData, setRiskPatientListData] = useState<
      RiskPatientListData[]
    >([]);
    const [clickedMember, handleOnclickedMember] = useState<string>();
    const [riskPatientDetails, setRiskPatientDetails] = useState<
      RiskPatientDetailss[]
    >([]);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [areDatesReady, setAreDatesReady] = useState<boolean>(false);

    //constants
    const { classes } = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const historyState: any = location.state;
    const riskTier: string = historyState.tier;
    const riskType: string = historyState.type;
    const memberIds = historyState.memberIds;
    const pageCount = Math.ceil(memberIds?.length / pageSize);
    const employerGroupStore = useStores().employerGroupStore;
    const memberSummaryStore = useStores().memberSummaryStore;
    let currentPagePatientList: any[] = [];
    const infoIcon = getInfoIcon(
      `Top 3 Diagnosis based on Total Cost.`,
      () => {},
      {
        display: 'flex',
        alignItems: 'center',
      },
    );

    //functions
    const getTableColumns = () => {
      return collapsiblePatientTableColumns.map((item) => ({
        ...item,
        name:
          item.name === 'Diagnosis' ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'left',
                ...collapsiblePatientTableHeaderStyles,
              }}
            >
              <div style={{ ...collapsiblePatientTableHeaderStyles }}>
                Diagnosis
              </div>
              <div>{infoIcon}</div>
            </div>
          ) : (
            item.name
          ),
      }));
    };

    const getClaims = async () => {
      const tableRowData: any[] = [];
      await Promise.all(
        currentPagePatientList!.map(async (item) => {
          const element = await getMemberClaims(
            item['Member ID'],
            item['Chronic Conditions'],
            item['Total Cost'],
            item['Previous Year Cost'],
            item['Recent Visit'],
            item['Trigger Conditions'],
            item['Diagnosis'],
          );
          tableRowData.push(element);
        }),
      );
      const sortedData = tableRowData.sort((p1, p2) =>
        p1.cost < p2.cost ? 1 : p1.cost > p2.cost ? -1 : 0,
      );
      setRiskPatientDetails([...sortedData]);
    };

    const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
      setPage(page);
    };

    const getRiskPatientPaitentlistData = () => {
      const table: any[] = [];

      riskPatientDetails?.forEach(async (item) => {
        const riskElement: any = [];
        riskElement.push(item.member_unique_id ?? '-');
        riskElement.push(item.recent_visit ?? '-');
        riskElement.push(
          item.chronic_conditions?.length !== 0
            ? getTextWithToolTip(item.chronic_conditions, 20)
            : '-',
        );
        riskElement.push(
          item.diagnosis?.length !== 0
            ? getTextWithToolTip(
                item.diagnosis?.map((item: any) => {
                  return `${item.diagnosis_desc} - ${numberToCurrencyFormatter(
                    item.diagnosis_total_paid,
                  )}`;
                }),
                20,
              )
            : '-',
        );
        riskElement.push(
          item.trigger_conditions
            ? getTextWithToolTip(item.trigger_conditions, 20)
            : '-',
        );
        riskElement.push(numberToCurrencyFormatter(item.cost, true));
        riskElement.push(
          numberToCurrencyFormatter(item.previous_year_cost, true),
        );
        riskElement.push(
          <MedicalHistoryDetails
            riskPatientDetails={formatMemberClaim(
              item.claimData,
              item.member_unique_id,
            )}
          />,
        );
        table.push(riskElement);
      });
      return table;
    };

    //api calls
    const getMemberClaims = async (
      memberid: string,
      chronic_conditions: string[],
      cost: number,
      previous_year_cost: number,
      recent_visit: string,
      trigger_conditions: string[],
      diagnosis: any[],
    ) => {
      return await axios
        .post(
          properties.aiqBaseUrl +
            properties.membersBaseUrl +
            properties.memberDetails,
          {
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            startDate: startDate,
            endDate: endDate,
            member_unique_id: [memberid],
            claim_id_list: [],
          },
        )
        .then((res) => {
          if (res?.status === 200) {
            const memberClaim: MemberClaims[] = res?.data?.data;
            const element: RiskPatientDetailss = {
              member_unique_id: memberid,
              chronic_conditions: chronic_conditions,
              cost: cost,
              previous_year_cost: previous_year_cost,
              recent_visit: recent_visit,
              trigger_conditions: trigger_conditions,
              diagnosis: diagnosis,
              claimData: memberClaim,
            };

            return element;
          }
          return null;
        });
    };

    const postRiskPatientListData = async (pageNumber: number) => {
      // const dateFilterResponse = employerGroupStore.employerGroupResponseData;
      // const monthNumber = MonthMap.get(dateFilterResponse.end_month)
      //   ?.monthNumber;
      // const defaultDate = new Date(
      //   monthNumber + '-01-' + dateFilterResponse.end_year,
      // );
      // const startYear = moment(defaultDate).subtract(11, 'months').year();

      await axios
        .post(properties.aiqBaseUrl + properties.membersList, {
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
          startYear: moment(startDate, 'YYYY-MM-DD').year(),
          pageNumber: pageNumber - 1,
          pageSize: pageSize,
          sortField: 'totalCost',
          sortOrder: -1,
          category: 'chronic',
          startDate: startDate,
          endDate: endDate,
          max_claim_date:
            employerGroupStore.employerGroupResponseData.max_claim_date,
          columnList: defaultRiskPatientColumns,
          diagnosis_count: 3,
          diagnosis_sort_field: 'totalPaid',
          member_unique_id_list: memberIds,
        })
        .then((res) => {
          if (res) {
            currentPagePatientList = [];
            res?.data?.data?.memberList?.forEach(
              //eslint-disable max-nested-callbacks

              (item: any) => {
                currentPagePatientList.push(item);
              },
            );
            setRiskPatientListData([...currentPagePatientList]);
          }
        });
    };

    const apiCalls = async () => {
      await Promise.all([postRiskPatientListData(page)]).then(async () => {
        await Promise.all([await getClaims()]).then(() => {
          setLoading(false);
        });
      });
    };

    //useEffects
    useEffect(() => {
      setLoading(true);
      Boolean(startDate !== '' && endDate !== '') ? apiCalls() : '';
    }, [page, areDatesReady]);

    useEffect(() => {
      setStartDate(employerGroupStore?.selectedDuration?.startDate);
      setEndDate(employerGroupStore?.selectedDuration?.endDate);
      setAreDatesReady((prev) => !prev);
    }, []);

    useEffect(() => {
      if (clickedMember) {
        memberSummaryStore.setPathDetails([
          [
            riskPatientDetailsMessage.breadCrumb.text,
            riskPatientDetailsMessage.breadCrumb.summary,
            {
              color: patientAccessTheme.palette.primary[500],
              fontWeight: 500,
            },
            () => {
              navigate(SUMMARY);
            },
          ],
          [
            riskPatientDetailsMessage.breadCrumb.text,
            riskPatientDetailsMessage.breadCrumb.riskPatientdetails,
            {
              color: patientAccessTheme.palette.text.highemphasis,
              fontWeight: 600,
            },
          ],
        ]);

        navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
      }
    }, [clickedMember]);

    return (
      <Grid container className={classes.root} direction="row">
        <Grid style={{ height: '22px' }}>
          <Breadcrumbs
            itemList={[
              [
                riskPatientDetailsMessage.breadCrumb.text,
                riskPatientDetailsMessage.breadCrumb.summary,
                {
                  color: patientAccessTheme.palette.primary[500],
                  fontWeight: 500,
                },
                () => {
                  navigate(SUMMARY);
                },
              ],
              [
                riskPatientDetailsMessage.breadCrumb.text,
                riskPatientDetailsMessage.breadCrumb.riskPatientdetails,
                {
                  color: patientAccessTheme.palette.text.highemphasis,
                  fontWeight: 600,
                },
              ],
            ]}
          ></Breadcrumbs>
        </Grid>
        <Grid style={{ marginTop: '19px' }}>
          <PageTitleAndSubTitle
            title={riskPatientDetailsMessage.titleAndSubtitle.title}
            subTitle={
              riskPatientDetailsMessage.titleAndSubtitle.subTitleStartString
            }
            subTitleStartPeriod={formatSubheadRiskTier(riskTier)}
            subTitleMiddleString={
              riskPatientDetailsMessage.titleAndSubtitle.subTitleMiddleString
            }
            subTitleEndPeriod={riskType}
            subTitleEndString={
              riskPatientDetailsMessage.titleAndSubtitle.subTitleEndString
            }
          />
        </Grid>
        <Grid style={{ marginTop: '28px' }}>
          {loading ? (
            <CircularLoader />
          ) : (
            <BasicTable
              displayType="row"
              columns={getTableColumns()}
              rowsData={getRiskPatientPaitentlistData()}
              isCollapsiblePatientTable={true}
              width="1178px"
              getMemberId={(value: string) => {
                handleOnclickedMember(value);
              }}
              headerCellHeight="46px"
              showPagination={true}
              pageCount={pageCount}
              handlePagination={handlePageChange}
              pageNumber={page}
            />
          )}
        </Grid>
      </Grid>
    );
  },
);

export default RiskPatientDetailsPage;
